import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import type { TagClass } from "@/lib/status";

interface TagProps extends HTMLAttributes<HTMLSpanElement> {
	variant: TagClass;
	noDot?: boolean;
}

export function Tag({ variant, noDot, className, ...props }: TagProps) {
	return (
		<span
			className={cn("tag", variant, noDot && "no-dot", className)}
			{...props}
		/>
	);
}
